import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FHEContainer } from 'data/components';
import { tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import FormCraftsman from './Form/FormCraftsman';
import { addCraftsman } from '../../data/Craftsman/actions';

class CraftsmanAdd extends PureComponent {
    static propTypes = {
        addCraftsman: PropTypes.func.isRequired
    };

    addCraftsman = data => {
        const { addCraftsman } = this.props;
        return addCraftsman(data);
    };
    render() {
        return (
            <FHEContainer withBackIcon>
                <FormCraftsman type="add" sendDataFunc={this.addCraftsman} />
            </FHEContainer>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default renderEnvComponent(
    'scenes/Craftsman/add',
    connect(
        mapStateToProps,
        (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addCraftsman }), dispatch)
    )(CraftsmanAdd)
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Craftsman/add.js